import { Link } from 'react-router-dom';
import { services } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <span className="text-background-50 font-bold text-sm">91</span>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                91.cn
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-xs">
              一站式互联网服务平台，为超过10万家企业提供域名注册、网站建设、云主机、企业邮箱等全方位数字化解决方案。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-800 flex items-center justify-center text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-background-50 mb-4 text-sm">服务产品</h3>
            <ul className="flex flex-col gap-2.5">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/category/${s.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-background-50 mb-4 text-sm">帮助中心</h3>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">联系我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">帮助文档</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-background-50 mb-4 text-sm">联系方式</h3>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-background-400 mt-0.5 text-sm"></i>
                <a href="tel:400-810-9191" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">400-810-9191</a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-background-400 mt-0.5 text-sm"></i>
                <a href="mailto:service@91.cn" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">service@91.cn</a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-background-400 mt-0.5 text-sm"></i>
                <span className="text-sm text-background-400">北京市海淀区中关村</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2010-2026 91.cn 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}